import ExtendableError from 'es6-error'
import { CountryService } from '@ynap/api-utils'
import { Value, CountryInfo } from '@ynap/address-form-v1'

interface CountriesApiUtil {
    ({ config }: { config: any }): Promise<Array<CountryInfo>>
}

function isCountryInfo<T>(value: CountryInfo | T): value is CountryInfo {
    return value != undefined && typeof (value as CountryInfo).countryCode == 'string' && typeof (value as CountryInfo).countryName == 'string'
}

export function isCountryInfoList<T>(value: Array<CountryInfo> | T): value is Array<CountryInfo> {
    return value != undefined && Array.isArray(value) && value.filter((elem) => !isCountryInfo(elem)).length === 0
}

export const getCountries: CountriesApiUtil = async (params) => {
    const { config, locale: { locale: langISO} = {} } = params
    const division = config.head.division
    const { baseUrl, clientId } = config.global.services.countryService
    const request = CountryService.getCountries({ baseUrl, brandId: division, clientId, locale: langISO })
    
    const response = await fetch(request)

    if (response.status >= 400) {
        throw new Error(`getCountries: Country error: ${response.url}`)
    }

    const responseJson = await response.json()
    if (!isCountryInfoList(responseJson)) {
        throw new Error(`getCountries: API response did not return a valid list of CountryInfo`)
    }

    return responseJson
}

export interface ProvincesApiResponse {
    countries: Array<{ code: string; dataType: string; data: Array<Value> }>
}

export type WcsError = {
    errorKey: string
    errorCode: string
    errorMessage: string
    errorParameters: Array<string>
}

class WcsErrorResponse extends ExtendableError {
    constructor(public response: { status: number; url: string }, public errors?: Array<WcsError>) {
        super(`Response error "${response.status}" received from "${response.url}"`)
    }
}

export { WcsErrorResponse }
